import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export class Toaster extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    if (this.props.message) {
      this.notify(this.props.toasterType, this.props.message);
    }
  }

  // componentWillReceiveProps(nextProps) {
  //     if (nextProps.message) {
  //         this.notify(nextProps.toasterType, nextProps.message)
  //     }
  // }

  notify(toasterType, message) {
    switch (toasterType) {
      case "success":
        toast.success(message);
        break;
      case "error":
        toast.error(message);
        break;
      case "warn":
        toast.warn(message);
        break;
      case "info":
        toast.info(message);
        break;
      default:
        toast(message);
        break;
    }
  }

  render() {
    return (
      <ToastContainer
        hideProgressBar={true}
        autoClose={4500}
        theme={"colored"}
      />
    );
  }
}

export default Toaster;
